import { getErrorMessage, NormalizedApiError } from '@smartsash/api-client';
import type { FieldPath, FieldValues, UseFormSetError } from 'react-hook-form';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

function firstMessage(value: unknown): string | undefined {
  if (typeof value === 'string') return value;
  if (Array.isArray(value)) return value.find((item): item is string => typeof item === 'string');
  return undefined;
}

export function applyApiFieldErrors<TValues extends FieldValues>(
  error: unknown,
  setError: UseFormSetError<TValues>,
): boolean {
  if (!(error instanceof NormalizedApiError) || !isRecord(error.details)) return false;

  let applied = false;
  for (const [field, value] of Object.entries(error.details)) {
    const message = firstMessage(value);
    if (message == null) continue;
    setError(field as FieldPath<TValues>, { type: 'server', message });
    applied = true;
  }
  return applied;
}

export function applyApiFormError<TValues extends FieldValues>(
  error: unknown,
  setError: UseFormSetError<TValues>,
  translate: DataScreenTranslate,
): void {
  if (applyApiFieldErrors(error, setError)) return;
  setError('root.server', { type: 'server', message: translate(getErrorMessage(error)) });
}

export type DataScreenTranslate = (key: string) => string;
